(function() {
'use strict';

angular
    .module('TR')
    .controller('SeatPlan', SeatPlan);

function SeatPlan(basketStore, tripService, $routeParams, flightSeatPlanService) {
    const sp = this;
    sp.showPlan = false;
    sp.totalPrice = 0;
    sp.minCostPerPerson = 0;

    sp.closePlan = function() {
        sp.showPlan = false;
    };

    sp.resetSeats = function() {
        for (const p of sp.flightSeatPlan.Passengers) {
            for (const s of p.Seats) {
                s.Number = null;
                s.Price = 0;
            }
        }
        sp.totalPrice = 0;
    };

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        return basketStore.flight(trip.BasketId);
    }).then(function(flight) {
        if (!flight.Details.CanSelectSeats) {
            return;
        }

        return flightSeatPlanService.getSeatPlan({
            DetailsSessionId: flight.Details.DetailsId
        });
    }).then(function(plan) {
        if (plan) {
            sp.flightSeatPlan = plan;
        }
    });
}
})();
